import { isCliReturnUrl } from './redirect-utils';

const CLI_RETURN_KEY = 'cli-return';

/**
 * Narrows `r` to a pending /cli return, one that {@link isCliReturnUrl}
 * accepts, so the steps that call it can pass it on as `r`. The round trip
 * through an identity provider keeps it in sessionStorage instead
 * ({@link rememberCliReturn} / {@link takeCliReturn}), because Cognito's
 * callback brings back only the code.
 */
export function cliReturnFrom(value: string | null): string | null {
  const isCliReturn = isCliReturnUrl(value, window.location.origin);
  return isCliReturn ? value : null;
}

/** Called on every SSO start: keeps a pending /cli return, clears a stale one. */
export function rememberCliReturn(value: string | null): void {
  const cliReturn = cliReturnFrom(value);
  if (!cliReturn) {
    sessionStorage.removeItem(CLI_RETURN_KEY);
    return;
  }
  sessionStorage.setItem(CLI_RETURN_KEY, cliReturn);
}

export function takeCliReturn(): string | null {
  const cliReturn = sessionStorage.getItem(CLI_RETURN_KEY);
  sessionStorage.removeItem(CLI_RETURN_KEY);
  return cliReturn;
}
